import { AuthState } from '@okta/okta-auth-js';

import { CommodityGroups } from '../../services/backend/CommodityGroups';
import { useBaseApiClient } from '../useBaseApiClient';

export const useCommodityGroups: () => CommodityGroups<AuthState> = () => {
  return useBaseApiClient(CommodityGroups);
};
